import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { CallbackComponent } from './callback.component';
import { CallbackRoutingModule } from './callback-routing.module';

/**
 * Module for Auht0 login callbacks
 */
@NgModule({
  imports: [SharedProviderModule, CallbackRoutingModule],
  exports: [CallbackComponent],
  declarations: [CallbackComponent],
  providers: []
})
export class CallbackModule {
}
